<script lang="ts">
    import Bid from './BidsTab/Bid.svelte'
    import { bidStore } from '../../stores'
</script>

<div class="auction-box-scrollable">
    <ul class="auctions-bids-list">
        {#each $bidStore as bid (bid.id)}
            <Bid {bid} />
        {/each}
    </ul>
</div>